// extracted by mini-css-extract-plugin
module.exports = {"equalColumn":"EditPromotion_equalColumn__1zl8w","smallColumn":"EditPromotion_smallColumn__k8-YV","mediumColumn":"EditPromotion_mediumColumn__1lUtN"};